import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export const Testimonials = (props) => {
  return (
    <div id="testimonials" style={{ background: "#fff", padding: "60px 0" }}>
      <div className="container">
        <div className="section-title text-center">
          <h2 style={{ color: "#000", fontWeight: 700, letterSpacing: 1 }}>TESTIMONIALS</h2>
        </div>
        <Swiper
          modules={[Navigation, Pagination, A11y]}
          spaceBetween={30}
          slidesPerView={3}
          navigation
          pagination={{ clickable: true }}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          style={{ padding: "40px 0" }}
        >
          {props.data
            ? props.data.map((d, i) => (
                <SwiperSlide key={`${d.name}-${i}`}>
                  <div className="testimonial-card">
                    <div className="testimonial-img-wrapper">
                      <img src={d.img} alt={d.name} className="testimonial-img" />
                    </div>
                    <div className="testimonial-quote">
                      <i className="fa fa-quote-left quote-icon" aria-hidden="true"></i>
                      <p>{d.text}</p>
                    </div>
                    <div className="testimonial-meta">
                      <span className="testimonial-name">{d.name}</span>
                      {d.job && <span className="testimonial-job"> {d.job}</span>}
                    </div>
                  </div>
                </SwiperSlide>
              ))
            : "loading"}
        </Swiper>
      </div>
    </div>
  );
};
